/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { getRestEndpoint } from 'src/app/helpers/api-url';

import { IClaimStatusRouting } from '../../interfaces/claim-status/claim-status.interface';

@Injectable({
  providedIn: 'root',
})
export class ClaimStatusRoutingService {
  constructor(private http: HttpClient) {}

  createClaimStatusRouting(
    claimStatusRouting: IClaimStatusRouting,
  ): Observable<any> {
    return this.http
      .post<any>(
        `${getRestEndpoint()}/claims/status/routing`,
        claimStatusRouting,
      )
      .pipe(
        catchError((error: HttpErrorResponse) => {
          return throwError(() => {
            return error;
          });
        }),
      );
  }

  editClaimStatusRouting(
    claimStatusRouting: IClaimStatusRouting,
  ): Observable<any> {
    const ID = claimStatusRouting.id;
    return this.http
      .put<any>(
        `${getRestEndpoint()}/claims/status/routing/${ID}`,
        claimStatusRouting,
      )
      .pipe(
        catchError((error: HttpErrorResponse) => {
          return throwError(() => {
            return error;
          });
        }),
      );
  }
}
